export const BUTTON_COLORS = ["primary", "neutral", "secondary", "success", "info", "warning", "error", "bakery", "dairy", "drinks", "dry", "fruit", "meat", "non", "sauces", "snacks"] as const;

export const BUTTON_VARIANTS = ["solid", "outline", "soft", "subtle", "ghost", "link"] as const;

export type ButtonColor = (typeof BUTTON_COLORS)[number];

export type ButtonVariant = (typeof BUTTON_VARIANTS)[number];
